type PaymentMethodSource = {
  paymentMethod?: string | null
  gateway?: string | null
  achToken?: string | null
  CardNumber?: string | null
  number?: string | null
  card?: {
    achToken?: string | null
    CardNumber?: string | null
    number?: string | null
  } | null
}

function cleanString(value: unknown) {
  if (typeof value !== 'string') return null

  const trimmed = value.trim()

  return trimmed || null
}

function normalizeExplicitPaymentMethod(value: unknown) {
  const method = cleanString(value)

  if (!method) return null

  const normalized = method.toLowerCase().replace(/[-_]/g, ' ')

  if (normalized === 'cc' || normalized === 'card' || normalized === 'credit card') {
    return 'Credit Card'
  }

  if (
    normalized === 'ach' ||
    normalized === 'echeck' ||
    normalized === 'e check' ||
    normalized === 'bank account' ||
    normalized === 'bank transfer'
  ) {
    return 'ACH'
  }

  return method
}

export function resolvePaymentMethodLabel(source: PaymentMethodSource = {}) {
  const explicitMethod = normalizeExplicitPaymentMethod(source.paymentMethod)

  if (explicitMethod) return explicitMethod

  const gateway = cleanString(source.gateway)
  const normalizedGateway = gateway?.toLowerCase()

  if (normalizedGateway === 'check') return 'Check'
  if (normalizedGateway === 'wire') return 'Wire Transfer'

  if (cleanString(source.achToken) || cleanString(source.card?.achToken)) {
    return 'ACH'
  }

  if (
    cleanString(source.CardNumber) ||
    cleanString(source.number) ||
    cleanString(source.card?.CardNumber) ||
    cleanString(source.card?.number)
  ) {
    return 'Credit Card'
  }

  return gateway
}
